import ToastrService from "../../services/toastService";


export const Logout = async (navigate) => {
    try {
        localStorage.clear();
        navigate("/");
        ToastrService.success("Logged out successfully!")
    } catch (err) {
        console.error("Logout error:", err);
    }
};



export const shouldLogout = (err) => {

    const status = err?.data?.statusCode;
    const message = err?.data?.message;

    return (
        status === 401 &&
        [
            "Access Denied! Invalid User",
            "Unauthorized User",
            "Invalid User",
            "Inactive User"
        ].includes(message)
    );
};